<script setup lang="ts">
import LandingTitleLayout from '../LandingTitleLayout.vue';

const props = withDefaults(
  defineProps<{
    variant?: 'client' | 'partner';
  }>(),
  { variant: 'client' }
);

const { staticUrl } = useRuntimeConfig().public;
</script>

<template>
  <div class="container position-relative">
    <!-- <div class="circle"></div> -->
    <!-- <div class="circle"></div> -->
    <LandingTitleLayout>
      <template #title>
        <template v-if="props.variant === 'client'">
          Выбирай
          <span>самостоятельно</span>
        </template>
        <template v-else>
          Профиль —
          <span>твой личный сайт</span>
        </template>
      </template>
      <template #subtitle>
        <template v-if="props.variant === 'client'">
          Запись к мастеру на услуги красоты больше не проблема. Ты увидишь
          большой список лучших мастеров и салонов красоты рядом с тобой, твоим
          домом или работой. Не нужно ждать ответа или согласовывать время с
          мастером — выбирай удобное время и записывайся сразу к нескольким
          мастерам.
        </template>
        <template v-else>
          Портфолио, которому доверяют люди. Заменит или дополнит соцсети и
          блог. Учтено все необходимое для клиента: от рабочего графика до
          отзывов. Отправь клиенту ссылку, пусть сайт говорит за тебя
        </template>
      </template>
    </LandingTitleLayout>

    <div v-if="props.variant === 'client'" class="app-image">
      <div>
        <NuxtImg format="webp" :src="`${staticUrl}/landing/app-back.png`" />
      </div>
      <div>
        <NuxtImg format="webp" :src="`${staticUrl}/landing/app-front.png`" />
      </div>
    </div>
    <div v-else class="app-image">
      <div>
        <NuxtImg
          format="webp"
          :src="`${staticUrl}/landing/app-partner-back.jpg`"
          class="rounded-image"
        />
      </div>
      <div>
        <NuxtImg
          format="webp"
          :src="`${staticUrl}/landing/app-partner-front.jpg`"
          class="rounded-image"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.app-image {
  position: relative;
  width: 800px;
  max-width: 100%;
  margin: 0 auto;
  padding: 82px 0 85px;

  @include media-breakpoint-down(md) {
    padding: 40px 0 36px;
  }

  & div:first-child {
    width: 100%;
    padding: 10px;
    background: #fff;
    border-radius: 24px;
    box-shadow:
      1.1125px 1.1125px 3.33749px rgba(80, 88, 113, 0.25),
      4.44999px 4.44999px 11.125px rgba(80, 88, 113, 0.08),
      inset 3.33749px 3.33749px 6.67499px rgba(121, 135, 176, 0.08),
      inset -4.44999px -4.44999px 16.6875px rgba(121, 135, 176, 0.25);

    @include media-breakpoint-down(md) {
      padding: 5px;
      box-shadow:
        0.476385px 0.476385px 1.42916px rgba(80, 88, 113, 0.25),
        1.90554px 1.90554px 4.76385px rgba(80, 88, 113, 0.08),
        inset 1.42916px 1.42916px 2.85831px rgba(121, 135, 176, 0.08),
        inset -1.90554px -1.90554px 7.14578px rgba(121, 135, 176, 0.25);
      border-radius: 16px;
    }

    img {
      width: 100%;
    }
  }

  & div:last-child {
    position: absolute;
    top: 0;
    left: 135px;
    padding: 10px;
    background: #ffffff;
    box-shadow:
      1.64958px 1.64958px 4.94875px rgba(80, 88, 113, 0.25),
      6.59834px 6.59834px 16.4958px rgba(80, 88, 113, 0.08),
      inset 4.94875px 4.94875px 9.89751px rgba(121, 135, 176, 0.08),
      inset -6.59834px -6.59834px 24.7438px rgba(121, 135, 176, 0.25);
    border-radius: 32px;

    @include media-breakpoint-down(lg) {
      max-width: 280px;
    }

    @include media-breakpoint-down(md) {
      max-width: 190px;
      padding: 5px;
      left: 92px;
      box-shadow:
        0.706372px 0.706372px 2.11912px rgba(80, 88, 113, 0.25),
        2.82549px 2.82549px 7.06372px rgba(80, 88, 113, 0.08),
        inset 2.11912px 2.11912px 4.23823px rgba(121, 135, 176, 0.08),
        inset -2.82549px -2.82549px 10.5956px rgba(121, 135, 176, 0.25);
      border-radius: 16px;
    }
    @include media-breakpoint-down(sm) {
      max-width: 132px;
      left: 44px;
    }

    img {
      width: 100%;
    }
  }

  .rounded-image {
    border-radius: 32px;

    @include media-breakpoint-down(md) {
      border-radius: 16px;
    }
  }
}

.circle {
  position: absolute;
  z-index: 0;
  width: 400px;
  height: 400px;
  /* filter: blur(500px); -- slow on safari */

  @include media-breakpoint-down(md) {
    width: 50%;
  }

  &:nth-child(1) {
    top: 230px;
    left: 0;
    background: #f1f1ff;
  }

  &:nth-child(2) {
    top: 230px;
    right: 0;
    background: #dae6ff;
  }
}
</style>
